import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import CustomSelect from "../../../../components/Select/Select";
import {
  createVitalsByAppointmentIdWoLoader,
  deleteVitalsByIdWoLoader,
  getVitalGroupsDetailsByIdWoLoader,
  getVitalGroupsWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";
import { delBtn } from "../../../../util/CommonIconStyle";

const initValues = { group: null };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };

const PetVitals = () => {
  const dispatch = useDispatch();
  const [createVsble, setCreateVsble] = useState(false);
  const [vitalValues, setVitalValues] = useState(initValues);
  const [selecetdItem, setSelectedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [isGroupErr, setGroupErr] = useState(false);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { vitalGroups, vitalListById } = useSelector((state) => state?.clinic);

  useEffect(() => {
    callApi();
    dispatch(getVitalGroupsWoLoader());
  }, []);

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(reqDet?.appointment?.appointmentId)
    );
  };

  const getVitalGroupDetailsById = (grpId, obj) => {
    dispatch(getVitalGroupsDetailsByIdWoLoader(grpId)).then((res) => {
      if (res?.payload) {
        let reqObj = { ...obj };
        res?.payload?.forEach((det) => {
          reqObj = { ...reqObj, [det?.vitalName]: "" };
        });
        setVitalValues(reqObj);
      }
    });
  };

  const onChange = (name, value) => {
    if (name === "group") {
      setGroupErr(!value?.vitalGroupId ? true : false);
      if (value?.vitalGroupId)
        getVitalGroupDetailsById(value?.vitalGroupId, {
          ...vitalValues,
          [name]: value,
        });
    }
    setVitalValues({ ...vitalValues, [name]: value });
  };

  const getVitalGroups = () => {
    return vitalGroups?.map((item) => ({
      name: item?.groupName,
      value: item?.groupName,
      vitalGroupId: item?.roomId,
    }));
  };

  const handleSave = () => {
    if (!vitalValues?.group?.vitalGroupId) return setGroupErr(true);
    let reqData = { remarks: vitalValues?.remarks };
    vitalListById?.forEach((li) => {
      reqData[li?.vitalName] = vitalValues?.[li?.vitalName];
    });
    const data = {
      vitalGroupId: vitalValues?.group?.vitalGroupId,
      vitalGroup: vitalValues?.group?.value,
      data: [reqData],
    };
    if (selecetdItem) data.vitalId = selecetdItem?.vitalId;
    dispatch(
      createVitalsByAppointmentIdWoLoader({
        apntId: reqDet?.appointment?.appointmentId,
        data,
      })
    ).then((res) => {
      if (res?.payload) {
        setCreateVsble(false);
        callApi();
        setVitalValues(initValues);
        setSelectedItem(null);
        setGroupErr(false);
      }
    });
  };

  const onEdit = (dta) => {
    if (reqDet?.appointment?.appointmentStatus?.toLowerCase() !== "completed") {
      return;
    }
    setSelectedItem(dta);
    const reqObj = {
      group: {
        name: dta?.vitalGroup,
        value: dta?.vitalGroup,
        vitalGroupId: dta?.vitalGroupId,
      },
    };
    Object.keys(dta?.data?.[0])?.forEach(function (key, index) {
      reqObj[key] = dta?.data?.[0]?.[key];
    });
    setVitalValues(reqObj);
    setCreateVsble(true);
  };

  const handleDelete = (pv) => {
    setSelectedItem(pv);
    setDelModVsble(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedItem(null);
  };

  const onCofirmDelete = () => {
    if (!selecetdItem?.vitalId) return;
    dispatch(deleteVitalsByIdWoLoader(selecetdItem?.vitalId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        callApi();
      }
    });
  };

  return (
    <>
      <div className="ph20 mt10">
        {!createVsble && (
          <div>
            <div className="flex-row-ali-cen mh20">
              <div className="w65Per">
                <Typography className="font-bold blue-color fs12">
                  Name
                </Typography>
              </div>
              <div className="w25Per">
                <Typography className="font-bold blue-color fs12">
                  Recorded Date/Time
                </Typography>
              </div>
              <div className="w5Per" />
            </div>
            <div className="blue-hor-split mt5" />
            {reqDet?.vitals?.map((pv) => (
              <div className="flex-row-ali-cen mh20 mt10" key={pv?.vitalId}>
                <div className="w65Per" onClick={() => onEdit(pv)}>
                  <Custom3dotString
                    str={pv?.vitalGroup}
                    className="txt-semi-bold blue-color fs12 underline cursor"
                  />
                </div>
                <div className="w25Per">
                  <Typography className="font-medium gray34 fs12">
                    {moment(new Date(pv?.updatedDate)).format(
                      "DD MMM YYYY, HH:mm"
                    )}
                  </Typography>
                </div>
                <div className="w5Per">
                  <div className="cursor" onClick={() => handleDelete(pv)}>
                    <div className="flex-center">
                      <DeleteOutlineIcon sx={delBtn} />
                    </div>
                    <Typography className="red3 fs8 txt-semi-bold text-align-center">
                      Delete
                    </Typography>
                  </div>
                </div>
              </div>
            ))}
            {reqDet?.appointment?.appointmentStatus?.toLowerCase() !==
            "completed" ? (
              <div
                className="flex-row-ali-cen mt20 cursor"
                onClick={() => setCreateVsble(true)}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={addIcon} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
            ) : null}
          </div>
        )}
        {createVsble && (
          <Grid container spacing={2} className="ph10">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <Typography className="blue-color fs14 txt-semi-bold mt5">
                  Vital Group :
                </Typography>
                <div className="w70Per ml20">
                  <CustomSelect
                    list={getVitalGroups()}
                    value={vitalValues?.group}
                    handleChange={(e, value) => onChange("group", value)}
                    search
                    error={isGroupErr}
                    helperText={isGroupErr ? "This field is required" : ""}
                  />
                </div>
              </div>
            </Grid>
            {selecetdItem ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="gray35 fs14 txt-semi-bold">
                  Last Recorded:{" "}
                  {moment(new Date(selecetdItem?.updatedDate)).format(
                    "DD MMM YYYY, HH:mm"
                  )}
                </Typography>
              </Grid>
            ) : null}
            {vitalValues?.group?.vitalGroupId &&
              vitalListById?.map((li, i) => {
                const isDrop = li?.inputType === "DropDown";
                const dropList = isDrop
                  ? li?.dropdown?.map((dl) => ({ name: dl, value: dl }))
                  : [];

                return (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    key={li?.vitalId}
                  >
                    <Typography className="font-bold fs14 gray34">
                      {li?.vitalName ?? ""}
                    </Typography>
                    <div className="flex-row mb5">
                      <Typography className="fs14 gray34 txt-regular">
                        {li?.unit}
                        {/* ({li?.lowerRange}
                    {li?.upperRange?.length > 0 ? ` - ${li?.upperRange}` : ""}) */}
                      </Typography>
                      {/* <div className="flex1-end pr10">
                <div className="green-dot" />
              </div> */}
                    </div>
                    {isDrop ? (
                      <CustomSelect
                        list={dropList}
                        value={vitalValues?.[li?.vitalName]}
                        handleChange={(e) =>
                          onChange(li?.vitalName, e?.target?.value)
                        }
                        select
                      />
                    ) : (
                      <CustomTextField
                        fullWidth
                        value={vitalValues?.[li?.vitalName]}
                        handleChange={(e) =>
                          onChange(li?.vitalName, e?.target?.value)
                        }
                        // suffix="°F"
                      />
                    )}
                  </Grid>
                );
              })}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold fs14 gray34 mb5">
                Remarks
              </Typography>
              <CustomTextField
                fullWidth
                value={vitalValues?.remarks}
                handleChange={(e) => onChange("remarks", e?.target?.value)}
                multiline
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Save" smallBtn onClick={handleSave} />
                </div>
              </div>
            </Grid>
          </Grid>
        )}
      </div>
      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the Vital?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PetVitals;
